import { Listbox, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { classNames, coins } from '../../../utils/common';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const Option = ({ option }) => (
  <Listbox.Option
    className={({ active }) =>
      classNames(
        active ? 'bg-gray-300 text-white' : 'text-gray-900',
        'relative cursor-default select-none py-2 pl-3 pr-9',
      )
    }
    value={option}
  >
    {({ selected, active }) => (
      <>
        <span
          className={classNames(
            selected ? 'font-semibold' : 'font-normal',
            'block truncate',
            'text-gray-900',
          )}
        >
          {option.name}
        </span>

        {selected ? (
          <span
            className={classNames(
              active ? 'text-white' : 'text-green-secondary',
              'absolute inset-y-0 right-0 flex items-center pr-4',
            )}
          >
            <CheckIcon className="h-5 w-5" aria-hidden="true" />
          </span>
        ) : null}
      </>
    )}
  </Listbox.Option>
);

Option.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

const SelectCurrency = ({ onChange, icon }) => {  
  const [value, setValue] = useState(coins[0]);

  const handleOnChange = (value) => {
    setValue(value);
    onChange(value);
  };

  return (
    <Listbox value={value} onChange={handleOnChange}>
      {({ open }) => (
        <>
          <div className="relative">
            <Listbox.Button
              className={classNames(
                value?.schedule && 'text-yellow-700',
                'relative w-full cursor-default rounded-full bg-white py-1.5 pr-10 text-left ring-1 ring-inset sm:text-sm sm:leading-6 text-gray-900',
                icon ? 'pl-10' : 'pl-3',
              )}
            >
              {icon && (
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  {icon}
                </span>
              )}
              <span className="block truncate">{value?.name}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm text-left">
                {coins.map((coin) => (
                  <Option key={coin.value} option={coin} />
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};

SelectCurrency.propTypes = {
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.element,
};

export default SelectCurrency;
